import { GraphQLClient } from "graphql-request";
import {
  GetAllProductVariantsDocument,
  GetProductByIdDocument,
  GetProductDetailsByIdDocument,
  GetProductDetailsByIdQuery,
  GetAllProductsDocument,
  GetAllProductsQuery,
  GetProductByIdQuery,
  GetAllProductVariantsQuery,
  GetAllPagesByCategoryDocument,
  GetAllPagesByCategoryQuery,
  GetPageByNameContextLocaleDocument,
  GetPageByNameContextLocaleQuery,
} from "./graphql-generated";

export const gqlClient = new GraphQLClient(
  `https://${process.env.NEXT_PUBLIC_BV_DIRECTUS_URL}/graphql`,
  {}
);

export const prefetchWrapper =
  (fnQuery: Function) =>
  async ({ queryKey }: any) => {
    const [_key, parameters] = queryKey;
    return fnQuery(parameters);
  };

export const getAllProductVariantsDocument = async ({
  limit = 1000,
  offset = 0,
}: {
  limit?: number;
  offset?: number;
}) => {
  return gqlClient.request<GetAllProductVariantsQuery>(
    GetAllProductVariantsDocument,
    { limit, offset }
  );
};

export const getProductById = async ({ id }: any) => {
  return gqlClient.request<GetProductByIdQuery>(GetProductByIdDocument, { id });
};

export const getProductDetailById = async ({ id }: any) => {
  return gqlClient.request<GetProductDetailsByIdQuery>(
    GetProductDetailsByIdDocument,
    { id }
  );
};

export const getAllProducts = async () =>
  gqlClient.request<GetAllProductsQuery>(GetAllProductsDocument);

export const getAllPagesByCategory = async ({ type }: { type: string }) =>
  gqlClient.request<GetAllPagesByCategoryQuery>(GetAllPagesByCategoryDocument, {
    type,
  });

export const getPageByNameContextLocale = async ({
  name,
  context,
  locale,
}: {
  name: string;
  context: string;
  locale: string;
}) =>
  gqlClient.request<GetPageByNameContextLocaleQuery>(
    GetPageByNameContextLocaleDocument,
    { name, context, locale }
  );
